import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import styles from './Section.module.css'

type SectionProps = {
  /** Uppercase monospaced label on the left of the head rule. */
  label: string
  /** Optional counterpart on the right — "12 de 20", "3 jogos". */
  meta?: ReactNode
  /** Hairline instead of the full-strength rule, for a nested section. */
  isSubtle?: boolean
  className?: string | undefined
  children: ReactNode
}

/**
 * A labelled section with a rule under its head.
 *
 * This is the primitive the Placar direction is built on — survivor screens are
 * tables, so they are divided by rules and space rather than by card fills. Use
 * `Card` only where something genuinely needs to sit above the page ground.
 */
export function Section({ label, meta, isSubtle = false, className, children }: SectionProps) {
  return (
    <section className={clsx(styles.section, className)}>
      <div className={styles.head}>
        <span className={styles.label}>{label}</span>
        {meta !== undefined && <span className={styles.meta}>{meta}</span>}
      </div>
      <div className={clsx(styles.rule, isSubtle && styles.ruleSoft)} />
      <div className={styles.body}>{children}</div>
    </section>
  )
}
